import { Link } from 'react-router-dom';
import { mockPosts } from '../../api/mockData';

const ArchivePage = () => {
  // 如果没有文章，显示空状态
  if (mockPosts.length === 0) {
    return (
      <div className="archive-container">
        <h1 className="archive-title">FIFA文章归档</h1>
        <div className="archive-empty">
          <div className="archive-empty-icon">📄</div>
          <p className="archive-empty-text">暂无文章</p>
        </div>
      </div>
    );
  }

  return (
    <div className="archive-container">
      <h1 className="archive-title">FIFA文章归档</h1>
      <ul className="archive-list">
        {mockPosts.map(post => (
          <li key={post.id} className="archive-item">
            <Link to={`/post/${post.id}`} className="archive-link">
              {post.title}
            </Link>
            {/* 如果文章有日期或分类，可以添加 */}
            <div className="archive-meta">
              {post.date && (
                <span className="archive-date">{post.date}</span>
              )}
              {post.category && (
                <span className="archive-category">{post.category}</span>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ArchivePage;